import { BaseRouteService } from "core/services";

class ConfirmingReportItemRouteService extends BaseRouteService {
	constructor() {
		super("confirming-report-items");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,confirmingReportId,salesOrderNumber}`, filter);
	}	
	
	findGrouped(filter) {
		return super.find(`${this.base}/grouped/{?searchQuery,page,rpp,sort,embed,fields,confirmingReportId}`, filter);
	}

	getPumpAndPoleItems(filter) {
		return super.find(`${this.base}/pump-and-pole-items/{?searchQuery,page,rpp,sort,embed,fields,confirmingReportId}`, filter);
	}

	getSpecificConfirmingStatusItems(filter) {
		return super.find(`${this.base}/specific-confirming-status-items/{?searchQuery,page,rpp,sort,embed,fields,confirmingReportId}`, filter);
	}
}

export default ConfirmingReportItemRouteService;